export const services = [
  {
    id: 'market-expansion',
    title: '全球市场拓展',
    subtitle: 'Global Market Expansion',
    description: '为您的企业量身定制国际化市场拓展方案，从市场调研、定位分析到落地执行，助您精准切入全球目标市场，实现业务快速增长。',
    icon: 'ri-global-line',
    features: ['目标市场调研分析', '市场进入策略制定', '本地化品牌建设', '渠道合作伙伴对接'],
    imageQuery: 'Professional business people discussing global market expansion strategy in modern office with world map background warm golden tones corporate',
  },
  {
    id: 'cross-border-cooperation',
    title: '跨境业务合作',
    subtitle: 'Cross-Border Cooperation',
    description: '搭建跨境合作桥梁，整合全球优质商业资源，为企业寻找最佳合作伙伴，促成高效双赢的跨境业务合作。',
    icon: 'ri-handshake-line',
    features: ['合作伙伴筛选评估', '跨境合作谈判支持', '合作协议法律咨询', '合作项目全程管理'],
    imageQuery: 'Two business executives shaking hands across a table with global map projection elegant corporate setting warm amber lighting',
  },
  {
    id: 'resource-integration',
    title: '国际资源对接',
    subtitle: 'Global Resource Integration',
    description: '链接全球高端资源，包括技术、人才、资本、供应链等，为您的企业国际化发展提供全方位资源支持。',
    icon: 'ri-links-line',
    features: ['技术资源引进', '国际人才招募', '跨境投融资服务', '全球供应链优化'],
    imageQuery: 'Connected network nodes over world map with light beams connecting continents modern digital visualization warm corporate style',
  },
  {
    id: 'strategy-consulting',
    title: '国际化战略咨询',
    subtitle: 'International Strategy Consulting',
    description: '由资深国际化专家团队提供深度战略咨询服务，帮助您制定科学可行的国际化发展路线图。',
    icon: 'ri-lightbulb-line',
    features: ['国际化战略规划', '海外市场竞争力分析', '跨国组织架构设计', '国际化人才培养'],
    imageQuery: 'Senior consultants reviewing strategic documents around modern conference table professional corporate environment warm tones',
  },
  {
    id: 'brand-internationalization',
    title: '品牌国际化',
    subtitle: 'Brand Internationalization',
    description: '打造具有全球影响力的国际品牌，从品牌策略、视觉设计到传播推广，助力您的品牌走向世界舞台。',
    icon: 'ri-medal-line',
    features: ['国际品牌定位策略', '多语言品牌VI设计', '全球品牌传播方案', '国际媒体公关服务'],
    imageQuery: 'Creative brand strategy presentation on large screen modern creative agency workspace warm sophisticated atmosphere',
  },
  {
    id: 'digital-globalization',
    title: '数字全球化',
    subtitle: 'Digital Globalization',
    description: '利用数字技术赋能全球业务，提供跨境电商、数字营销、海外社媒运营等一站式数字全球化解决方案。',
    icon: 'ri-smartphone-line',
    features: ['跨境电商平台搭建', '海外社交媒体运营', '全球数字营销推广', '多语言网站建设'],
    imageQuery: 'Digital marketing dashboard with global analytics on multiple screens modern tech office warm ambient lighting',
  },
];

export const serviceCategories = [
  { id: 'all', label: '全部服务' },
  { id: 'market', label: '市场拓展' },
  { id: 'cooperation', label: '跨境合作' },
  { id: 'resources', label: '资源对接' },
  { id: 'strategy', label: '战略咨询' },
];

export const getServiceCategoryKey = (serviceId: string): string => {
  switch (serviceId) {
    case 'market-expansion': return 'market';
    case 'cross-border-cooperation': return 'cooperation';
    case 'resource-integration': return 'resources';
    case 'strategy-consulting': return 'strategy';
    case 'brand-internationalization': return 'market';
    case 'digital-globalization': return 'resources';
    default: return 'market';
  }
};